module.exports = __webpack_public_path__ + "img/5beecoins.c9336b1c.svg";